<template>
    <ul class="aggregator-list">
        <li v-if="!list.length">
            <span class="tag is-danger">List is empty</span> 
        </li>
        <li v-for="item in list" :key="item">
            <p class="control">
                <button class="button is-small" :class="{ 'is-success': activeItemName == item }" @click="selectItem(item)">{{ item }}</button>
            </p>
        </li>
    </ul>
</template>
<script>
export default {
    name: "item-list",
    props: {
        items: {
            type: Array,
            required: true
        },
        selectItem: {
            type: Function,
            required: false,
            default: () => {return}
        },
        activeItem: {
            type: String,
            required: false
        }
    },
    data(){
        return {
            activeItemName: null
        }
    },
    watch: {
        activeItem(){
            this.activeItemName = this.activeItem;
        }
    },
    computed: {
        list() {
            return this.items;
        }
    }
}
</script>
<style scoped lang="scss">
.aggregator-list {
    height: 200px;
    max-width: 450px;
    overflow: hidden;
    overflow-y: auto;

    li {
        margin-bottom: 5px;
    }
}
</style>


// WEBPACK FOOTER //
// front/src/components/common/item-list.vue